<template>
  <div class="page my-page-box">
    <div class="main-area">

      <div class="nav">
        <el-radio-group v-model="selectPaneType">
          <el-radio-button class="nav-item" label="valid" border>有效记录
          </el-radio-button>
          <el-radio-button class="nav-item" label="history" border>过期记录
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="main-content" v-if="selectPaneType === 'valid'">
        <el-table :data="tableData" border>
          <el-table-column label="访客姓名" width="120px">
            <template v-slot="scope">
              <span>{{ scope.row.visitor.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="访客号码" width="140px">
            <template v-slot="scope">
              <span>{{ scope.row.visitor.tel }}</span>
            </template>
          </el-table-column>
          <el-table-column label="申请类型" width="80px">
            <template v-slot="scope">
              <el-tag>{{ scope.row.apply.type === "INVITE_APPLY" ? "邀约" : "预约" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="开始时间" width="150px">
            <template v-slot="scope">
              <span>{{ scope.row.enterDate }} {{ scope.row.enterTime |simpleTimeFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结束时间" width="150px">
            <template v-slot="scope">
              <span>{{ scope.row.leaveDate }} {{ scope.row.leaveTime |simpleTimeFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否到访" width="80px">
            <template v-slot="scope">
              <el-tag>{{ scope.row.completeState |completeFilter }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="我的身份">
            <template v-slot="scope">
              <el-tag v-for="item in scope.row.related.split('|')" style="margin: 2px" :key="item">{{
                  item | roleFilter
                }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column v-if="selectPaneType === 'valid'" label="操作" width="80px">
            <template v-slot="scope">
              <el-button v-if="scope.row.actionShow" :disabled="!scope.row.actionEnable || !hasCommitPermission"
                         type="primary" size="mini"
                         @click="dealAction(scope.row)">{{ scope.row.actionShow }}
              </el-button>
            </template>
          </el-table-column>


          <el-table-column label="查看" width="80px">
            <template v-slot="scope">
              <el-button type="primary" size="mini" @click="showDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>


        </el-table>
        <div class="pager">
          <el-pagination layout="prev, pager, next"
                         :total="pagiTotal"
                         :page-size="pagiPageSize"
                         :pager-count="5"
                         :current-page.sync="index"
                         @current-change="handlePagination">
          </el-pagination>
        </div>
      </div>
      <div v-else class="main-content">
        <ArrivedRecordHistoryView :areaMap="areaMap"></ArrivedRecordHistoryView>
      </div>

    </div>

    <el-drawer title="到访详情" class="drawer-box" :visible.sync="drawerShow" :with-header="false" size="550px"
               :before-close="onDrawerClose">
      <div class="drawer-head">
        <div class="drawer-title">到访详情</div>
        <button @click="drawerShow = false" class="el-drawer__close-btn"><i class="el-icon-close"></i></button>
      </div>
      <div class="drawer-line"></div>
      <div class="drawer-content">
        <el-row>
          <el-col :span="12">
            <div class="grid-content">
              <h4>员工信息</h4>
              <div class="input-item-box"><span class="input-description">头像：</span>
                <el-image class="image-header" :src="selectRow.employee.headUrl" fit="cover">
                </el-image>
              </div>
              <div class="input-item-box"><span class="input-description">姓名：</span>
                <el-input size="mini"
                          v-model="selectRow.employee.name" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">手机：</span>
                <el-input size="mini"
                          v-model="selectRow.employee.tel" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">工号：</span>
                <el-input size="mini"
                          v-model="selectRow.employee.workId" :disabled="true" class="input-short"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content">
              <h4>访客信息</h4>
              <div class="input-item-box"><span class="input-description">头像：</span>
                <el-image class="image-header" :src="selectRow.visitor.headUrl" fit="cover">
                </el-image>
              </div>
              <div class="input-item-box"><span class="input-description">姓名：</span>
                <el-input size="mini"
                          v-model="selectRow.visitor.name" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">手机：</span>
                <el-input size="mini"
                          v-model="selectRow.visitor.tel" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">公司：</span>
                <el-input size="mini"
                          v-model="selectRow.visitor.company" :disabled="true" class="input-short"></el-input>
              </div>
            </div>

          </el-col>
        </el-row>
        <div class="grid-content">
          <h4>表单信息</h4>
          <div v-for="(item, index) in selectRow.apply.forms" :key="index" class="input-item-box"><span
              class="input-description-long">{{
              item.title
            }}:</span>
            <el-input size="mini" :placeholder="item.value" :disabled="true" class="input-long"></el-input>
          </div>
        </div>
        <div class="grid-content" v-if="noteList.length > 0">
          <h4>记录信息</h4>
          <template v-for="(item, index) in noteList">
            <div class="input-item-box" :key="`item.info` + index + '-0'"><span
                class="input-description-long">到访情况:</span>
              <el-input size="mini"
                        v-model="item.info" :disabled="true" class="input-long"></el-input>
            </div>
            <div class="input-item-box" :key="'item.enterCardNo' + index + '-0'"><span
                class="input-description-long">签到卡号:</span>
              <el-input size="mini"
                        v-model="item.enterCardNo" :disabled="true" class="input-long"></el-input>
            </div>
            <div class="input-item-box" :key="'superEnterAreaName' + index + '-0'"><span
                class="input-description-long">签到区域:</span>
              <el-input size="mini"
                        v-model="item.superEnterAreaName" :disabled="true" class="input-long"></el-input>
            </div>
            <div class="input-item-box" :key="'enterAreaName' + index + '-0'"><span
                class="input-description-long">签到子区域:</span>
              <el-input size="mini"
                        v-model="item.enterAreaName" :disabled="true" class="input-long"></el-input>
            </div>
            <div class="input-item-box" :key="'superLeaveAreaName' + index + '-0'"><span
                class="input-description-long">签离区域:</span>
              <el-input size="mini"
                        v-model="item.superLeaveAreaName" :disabled="true" class="input-long"></el-input>
            </div>
            <div class="input-item-box" :key="'leaveAreaName' + index + '-0'"><span
                class="input-description-long">签离子区域:</span>
              <el-input size="mini"
                        v-model="item.leaveAreaName" :disabled="true" class="input-long"></el-input>
            </div>
            <div class="input-item-box" :key="'item.timeCome' + index + '-1'"><span
                class="input-description-long">到访时间:</span>
              <el-input size="mini"
                        v-model="item.timeCome" :disabled="true" class="input-long"></el-input>
            </div>
            <div  class="input-item-box" :key="'item.timeLeave' + index + '-2'"><span
                class="input-description-long">离开时间:</span>
              <el-input size="mini"
                        v-model="item.timeLeave" :disabled="true" class="input-long"></el-input>
            </div>
            <div  class="input-item-box" :key="'item.enterCarNum' + index + '-2'"><span
                class="input-description-long">签到车牌:</span>
              <el-input size="mini"
                        v-model="item.enterCarNum" :disabled="true" class="input-long"></el-input>
            </div>
            <div style="margin-bottom: 20px" class="input-item-box" :key="'item.comments' + index + '-2'"><span
                class="input-description-long">签到备注:</span>
              <el-input size="mini"
                        v-model="item.comments" :disabled="true" class="input-long"></el-input>
            </div>

            <div style="margin-bottom: 20px" class="input-item-box" :key="'item.enterPhotoUrl'  +  + index"><span
                class="input-description-long">签到图片:</span>
              <el-image class="image-photo" :src="item.enterPhotoUrl" fit="cover">
                <div slot="error" class="image-photo">
                  <span v-if="item.enterPhotoUrl">加载失败</span>
                  <span v-else>没有拍照</span>
                </div>
              </el-image>
            </div>
          </template>

        </div>
      </div>
      <div class="drawer-line"></div>
      <div class="drawer-bottom">
        <el-button size="mini" @click="drawerShow = false">返回</el-button>
      </div>
    </el-drawer>

    <el-dialog title="选择签离人员" :visible.sync="dialogShow" width="30%">
      <el-table :data="checkoutList" @selection-change="onDrawTableSelectChange" border>
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="tel"></el-table-column>
        <el-table-column label="公司" prop="company"></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="checkoutSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {confirmCheckOut, getValidRecords} from "@/api/mobile/mobile-record-api";
import {getVisitorByBatch} from "@/api/mobile/mobile-visitor-api";
import {mixin_table} from "@/utils/mixin";
import {getFileUrl} from "@/utils/fileUploadUtils";
import {getAreaList} from "@/api/mobile/mobile-area-api";
import ArrivedRecordHistoryView from '@/pages/visitJobs/comp/ArrivedRecordHistoryView.vue'

export default {
  mixins: [mixin_table],
  components: {ArrivedRecordHistoryView},
  data() {
    return {
      selectPaneType: "valid",
      validRecords: [],

      selectRow: {
        apply: {
          forms: []
        },
        employee: {},
        visitor: {},

      },
      drawerShow: false,
      noteList: [],

      dialogShow: false,
      checkoutList: [],
      selectCheckoutList: [],
      areaMap: {},
    };
  },
  mounted() {
    getAreaList().then(({data}) => {
      if (data.code === 200) {
        this.areaTree = data.data
        this.areaMap = {}
        this.areaTree.forEach(item => {
          this.areaMap[item.id] = item
          ;(item.areas || []).forEach(subItem => {
            this.areaMap[subItem.id] = subItem
          })
        })
      } else {
        this.showServerErrMsg(data.msg)
      }
    }).catch(err => {
      console.log("doGetAllArea err", err)
      this.showNetErrMsg()
    })
    getValidRecords().then(({data}) => {
      console.log("getValidRecords", data)
      if (data.code === 200) {
        if (data.data === null) {
          return
        }
        this.validRecords = data.data
        this.tableAllData.push(...this.validRecords)
        this.tableShowData = this.tableAllData
        this.initPaginationTable()

        this.validRecords.forEach((item) => {
          if (!item.checkoutTime) {
            return
          }
          if ((item.apply.transferEmployeeId != null && item.apply.transferEmployeeId === this.$store.state.employeeLoginInfo.id) ||
              (item.apply.transferEmployeeId == null && item.employeeId === this.$store.state.employeeLoginInfo.id)) {
            this.$set(item, "actionShow", "签退")
            this.$set(item, "actionEnable", true)
          }
        })
      } else {
        this.showServerErrMsg(data.code)
        console.warn("getValidRecords failed", data)
      }
    }).catch((err) => {
      this.showNetErrMsg()
      console.error("getValidRecords failed", err)
    })
  },
  methods: {

    checkoutSubmit() {
      if (this.selectCheckoutList.length === 0) {
        this.$message.error("请选择签离人员")
        return
      }

      let ids = this.selectCheckoutList.map((item) => {
        return item.id
      })
      console.log("checkoutIds = ", ids)
      console.log("apply.id = ", this.selectRow.apply.id)

      confirmCheckOut(this.selectRow.apply.id, ids).then(({data}) => {
        console.log("data = ", data)

        if (data.code === 200) {
          this.$message.success("签离成功")
        } else {
          this.showServerErrMsg(data.code)
          console.warn("confirmCheckOut failed", data)
        }
      }).catch((err) => {
        this.showNetErrMsg()
        console.error("confirmCheckOut failed", err)
      })

      this.dialogShow = false
    },

    dealAction(row) {
      this.selectRow = JSON.parse(JSON.stringify(row))
      let visitorCodeList = []
      if (row.apply.accompanies) {
        visitorCodeList.push(...row.apply.accompanies.split("|"))
      }
      this.checkoutList = []
      this.checkoutList.push(row.apply.visitor)
      if (visitorCodeList.length === 0) {
        this.dialogShow = true
        return
      }
      getVisitorByBatch(visitorCodeList).then(({data}) => {
        if (data.code === 200) {
          this.checkoutList.push(...data.data)
          this.dialogShow = true
        } else {
          console.warn("getVisitorByBatch failed", data)
          this.dialogShow = true
        }
      }).catch((err) => {
        console.error("getVisitorByBatch failed", err)
        this.dialogShow = true
      })

    },

    showDetail(row) {

      this.selectRow = JSON.parse(JSON.stringify(row))
      if (this.selectRow.apply.forms === null) {
        this.selectRow.apply.forms = []
      }
      let employeeHead = require('@/assets/default_header.webp')
      if (row.employee.head) {
        employeeHead = getFileUrl(row.employee.head)
      }
      let visitorHead = require('@/assets/default_header.webp')
      if (row.visitor.head) {
        visitorHead = getFileUrl(row.visitor.head)
      }
      this.$set(this.selectRow.employee, "headUrl", employeeHead)
      this.$set(this.selectRow.visitor, "headUrl", visitorHead)
      this.selectRow.apply.forms = this.selectRow.apply.forms.filter((item) => {
        return item.type !== "beginTime" && item.type !== "endTime" && item.type !== "accompany"
      })
      let startTime = `${row.apply.beginDate} ${row.apply.beginTime.substr(0, 5)}`
      let endTime = `${row.apply.endDate} ${row.apply.endTime.substr(0, 5)}`
      this.selectRow.apply.forms.splice(0, 0,{title: "结束时间", value: endTime})
      this.selectRow.apply.forms.splice(0, 0,{title: "开始时间", value: startTime})

      this.noteList = []

      let item = row

      let info = "";
      let timeCome = "";
      let timeLeave = ""
      let enterPhotoUrl = ""
      let superEnterAreaName = ""
      let enterAreaName = ""
      let superLeaveAreaName = ""
      let leaveAreaName = ""
      if (item.enterAreaId) {
        let area = this.areaMap[item.enterAreaId]
        if (area) {
          if (area.parentId > 0) {
            let superArea = this.areaMap[area.parentId]
            if (superArea) {
              superEnterAreaName = superArea.name
            }
            enterAreaName = area.name
          } else {
            superEnterAreaName = area.name
          }
        }
      }
      if (item.leaveAreaId) {
        let area = this.areaMap[item.leaveAreaId]
        if (area) {
          if (area.parentId > 0) {
            let superArea = this.areaMap[area.parentId]
            if (superArea) {
              superLeaveAreaName = superArea.name
            }
            leaveAreaName = area.name
          } else {
            superLeaveAreaName = area.name
          }
        }
      }

      if (item.completeState) {
        info = this.$options.filters.tableDateFilter(item.completeState, 'param13')
      }
      if (item.enterDate && item.enterTime) {
        timeCome = `${item.enterDate} ${item.enterTime.substr(0, 5)}`
      }
      if (item.leaveDate && item.leaveTime) {
        timeLeave = `${item.leaveDate} ${item.leaveTime.substr(0, 5)}`
      }
      if (item.enterPhoto) {
        enterPhotoUrl = getFileUrl(item.enterPhoto)
      }
      let enterCarNum = ""
      if (item.enterCarNum) {
        enterCarNum = item.enterCarNum

      }
      let comments = ""
      if (item.comments) {
        comments = item.comments
      }
      let enterCardNo = ""
      if (item.enterCardNo){
        enterCardNo = item.enterCardNo
      }
      this.noteList.push({info, timeCome, timeLeave, enterPhotoUrl, superEnterAreaName, enterAreaName, superLeaveAreaName, leaveAreaName, enterCardNo, enterCarNum, comments})

      this.drawerShow = true
    },


    onDrawerClose(done) {
      done()
    },
    onDrawTableSelectChange(val) {
      this.selectCheckoutList = val
    },
  },

  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "STAFF":
          return true
        default:
          return false
      }
    },
  },

  filters: {
    tableDateFilter(value, prop) {
      if (prop === "param12") {
        switch (value) {
          case 'PROCESS':
            return "审批中"
          case 'PASS':
            return '已通过'
          case 'REJECT':
            return '已拒绝'
          case 'CANCEL':
            return '已撤销'
          case 'NONE':
            return '审批中'
          default:
            return value
        }
      } else if (prop === "param13") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else {
        return value
      }
    },
    timeShowFilter(value) {

      if (value === null || value.length < 19) {
        return value
      } else {
        return value.substring(0, 10) + " " + value.substring(11, 16)
      }
    },
    simpleTimeFilter(value) {
      if (value === null || value.length > 19) {
        return value
      } else {
        return value.substring(0, 5)
      }
    },
    applyTypeFilter(value) {
      if (value === "BOOK_APPLY") {
        return "预约"
      } else if (value === "INVITE_APPLY") {
        return "邀约"
      } else {
        return "其他"
      }
    },

    roleFilter(value) {
      if (value === "EMPLOYEE_VISITED") {
        return "被访者"
      } else if (value === "EMPLOYEE_APPROVED") {
        return "审核者"
      } else if (value === "EMPLOYEE_MAKECOPY") {
        return "抄送者"
      } else if (value === "EMPLOYEE_TRANSFER") {
        return "转签者"
      } else {
        return "其他"
      }
    },

    completeFilter(value) {
      switch (value) {
        case 'NO':
          return "未到访"
        case 'ENTER':
          return '已到访'
        case 'LEAVE':
          return '已离开'
        default:
          return value
      }
    },
  },

}
</script>

<style lang="less" scoped>

.main-content {
  background-color: white;

  .tab-title {
    font-weight: 550;
    font-size: 16px;
  }
}

.drawer-content {

  .input-short {
    width: 150px;
  }

  .input-long {
    width: 400px;
  }

  .grid-content {
    //padding-left: 8px;
    margin: 8px 8px 8px 20px;

  }

  .input-item-box {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding-bottom: 8px;
  }

  .input-description {
    display: inline-block;
    width: 80px;
  }

  .input-description-long {
    display: inline-block;
    width: 120px;
  }
}

.nav {
  padding-bottom: 10px;

  .nav-item {
    margin-right: 15px;
  }
}

/deep/ .el-radio-button__inner {
  background-color: #efefef;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 60px;
}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 60px;
}

.image-header {
  width: 80px;
  height: 100px;
}

.image-photo {
  width: 360px;
  height: 270px;
  line-height: 270px;
  text-align: center;
  background-color: #efefef;
}
.my-page-box {
  padding-left: 10vw;
  padding-right: 10vw;
}
</style>
